import { ActionContext, createNamespacedHelpers } from 'vuex'
import { get as getUser } from '@/serviceModels/services/user'
import { getUserPrivileges } from '@/serviceModels/services/privilege'
import { clear, Token, TokenType, setUserId, removeUserId } from "@/common/token";
import store from '@/store'
import { getlang } from '@/common/storage'

const state = {
    user: {},
    privileges: <any[]>[],
    roles: <any[]>[],
    menus: <any[]>[],
    token: <Token | undefined>undefined,
    userId: '',
    session_id: '',
    identity: {
        uid: "",
        authenticated: false,
        token: ""
    }
}

type stateType = typeof state;

export enum MutationsTypes {
    SetSessionID = 'setSessionID',
    SetToken = 'setToken',
    SetUserId = 'SetUserId',
    SetUserInfo = 'setUserInfo',
    SetIdentity = 'setIdentity',
    SetPrivileges = 'setPrivileges',
    Logout = 'logout'
}

export enum ActionsType {
    SetUserInfo = 'setUserInfo'
}

const mutations = {
    [MutationsTypes.Logout]: (state: stateType) => {
        state.identity.uid = ''
        state.identity.token = ''
        state.identity.authenticated = false
        state.token = undefined;
        state.userId = ''
        state.user = {}
        state.privileges = []
        state.menus = []

        clear()
        removeUserId()
    },
    [MutationsTypes.SetSessionID]: (state: stateType, sessionID: string) => {
        state.session_id = sessionID;
        state.identity.authenticated = true;
    },
    [MutationsTypes.SetToken]: (state: stateType, token: Token) => {
        

        state.token = token;
        state.identity.authenticated = true;
        state.identity.token = token.value;
    },
    [MutationsTypes.SetUserId]: (state: stateType, userId: string) => {
        state.userId = userId;
        setUserId(userId);
    },

    [MutationsTypes.SetUserInfo]: (state: stateType, { user = {}, privileges = [], roles = []} ) => {
        
        state.user = user
        state.roles = roles
        state.privileges = privileges
    },
    [MutationsTypes.SetPrivileges]: (state: stateType, privileges = []) => {
        state.privileges = privileges
    },
    SET_MENUS: (state: any, menus:any) => {
        state.menus = menus
    }
}

const actions = {
    async [ActionsType.SetUserInfo](context: ActionContext<stateType, any>) {
        let user:any = {}
        let lang:string = ''
        
        const { data, response} = await getUser()
        console.log('user response',response);
        if(response.status !== 200){
            throw new Error('获取用户信息失败')
        }else{
            lang =  getlang()
            store.commit(`app/SET_LANGUAGE`, lang)
            user = data
        }

        const privileges = [];

        /*
        const { data: privileges, error: privilegesError } = await getUserPrivileges(uid)
        if (privilegesError) {
            throw new Error('获取用户权限信息失败')
        }*/
        context.commit(MutationsTypes.SetUserInfo, { user, privileges})
    },
    setMenus({ commit }: { commit: Function }, val: any) {
        commit('SET_MENUS', val)
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}

export {
    stateType
}
